import {useMemo} from "react";
import {useSelector} from "react-redux";
import _ from "lodash";
import useViewMessageDetails from "./useViewMessageDetails";
import {
    buildConversation,
    buildOriginalConversation,
    isViewOriginalSupported
} from "../../../../../utilities/ConversationUtils";
import {RefreshToast} from "../../../../../common/RefreshToast";

export default function () {
    const { message, loadingMessage } = useViewMessageDetails();
    const originalConversation = useSelector(state => state.fullEmailConversation.emailConversationData);
    const originalConversationList = _.get(originalConversation, 'emailConversation') || [];
    const loadingOriginalConversation = useSelector(state => state.fullEmailConversation.loadingEmailConversation);
    const originalConversationError = useSelector(state => state.fullEmailConversation.error);
    const conversationFromTrendsList = useSelector(state => state.messages.trendsConversation);
    const loadingFromTrendsConversation = useSelector(state => state.messages.loadingTrendsConversation);
    const conversationError = useSelector(state => state.messages.trendsConversationError);
    const loading = loadingOriginalConversation || loadingFromTrendsConversation || loadingMessage;
    const error = originalConversationError || conversationError;
    const conversationMessageId = _.get(originalConversation, 'messageId') || _.get(conversationFromTrendsList, '0.id');

    const conversation = useMemo(() => {
        if(!_.isEmpty(message) && !loadingMessage) {
            const id = _.get(message, 'id');
            const isProactive = _.get(message, 'isProactive');
            const handleName = _.get(message, 'dataSourceHandle.name') || _.get(message, 'handle.name');
            const displayInApp = _.get(message, 'dataSourceHandle.displayInApp') || _.get(message, 'teamsAttributes.displayInApp');
            const sourceName = _.toString(_.get(message, 'sourceName') || _.get(message, 'msgDataSource.msgSource.name')).toLowerCase();
            const hasTrendsData = !loadingFromTrendsConversation && conversationFromTrendsList.length > 0;

            if(isViewOriginalSupported(sourceName, handleName, displayInApp)) {
                if(!loadingOriginalConversation && !_.isEmpty(originalConversation)) {
                    if(!loadingOriginalConversation && originalConversationList.length > 0 && originalConversation.messageId === id) {
                        console.log("building conversation from source; ", originalConversationList)
                        RefreshToast.close();
                        return buildOriginalConversation(originalConversationList);
                    }
                    /**
                     * Display only the incoming message if the conversation result is empty
                     */
                    console.log("loadingOriginalConversation: ", loadingOriginalConversation)
                    console.log("originalConversation: ", originalConversation)
                    console.log("building conversation from message; ", message)
                    return buildConversation([message]);
                }
            } else if(isProactive) {
                console.log("building conversation with proactive message")
                return buildConversation([message]);
            } else if(hasTrendsData) {
                console.log("building conversation from trends; ", conversationFromTrendsList)
                return buildConversation(_.get(conversationFromTrendsList, '0.conversation'));
            }
            /**
             * Display only the incoming message if fetching the conversation fails
             */
            if((!_.isEmpty(error)) && !loading) {
                console.log("building conversation from message due to error; ", error)
                return buildConversation([message]);
            }
        }
    }, [loading, conversationMessageId]) || [];

    return { message, conversation, loading };
}